import React, { useContext } from 'react';
import { instanceOf, node } from 'prop-types';
import { TCLFormApiContext } from '../context';
import TCLFormHelper from '../utils/TCLFormHelper';

export const TCLFormApiContextProvider = ({ value, children }) => (
  <TCLFormApiContext.Provider value={value}>{children}</TCLFormApiContext.Provider>
);

TCLFormApiContextProvider.propTypes = {
  children: node.isRequired,
  value: instanceOf(TCLFormHelper).isRequired,
};

export const useTCLFormApi = () => useContext(TCLFormApiContext);
